import { Button } from '../button/button';
import styles from './modal.module.css';

const CloseIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" className="Modal__close">
    <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
    <path d="M0 0h24v24H0z" fill="none" />
  </svg>
);

type Props = {
  closeModal: () => void;
};

export function Modal(props: Props) {
  const { closeModal } = props;

  return (
    <div className={styles.root} onClick={closeModal}>
      <div className={styles.card} onClick={(e) => e.stopPropagation()}>
        <button className={styles.close} onClick={closeModal} aria-label="Close modal">
          <CloseIcon />
        </button>
        <div className={styles.header}>
          <h2 className={styles.heading}>Prefer online learning?</h2>
          <p>
            Miki, a professional Japanese teacher of 10+ years experience, is the creator of{' '}
            <strong>JPSchoolGuide</strong> as well as
            <strong> ImaWakatta</strong> and <strong> HaiFive</strong>.
          </p>
        </div>

        <div className={styles.body}>
          <div className={styles.content}>
            <div>
              <h3 className={styles.subheading}>Self study options</h3>
              <p>ImaWakatta, provides the best online learning experience for the Japanese learner.</p>
            </div>
            <div className={styles.button}>
              <Button href="https://imawakatta.com" target="_blank" rel="noopener">
                Visit ImaWakatta
              </Button>
            </div>
          </div>

          <div className={styles.content}>
            <div>
              <h3 className={styles.subheading}>1 on 1 lessons</h3>
              <p>
                HaiFive offers 1 on 1 online lessons. If you happen to be in Melbourne, she also has in-person classes.
              </p>
            </div>
            <div className={styles.button}>
              <Button href="https://haifivejapanese.com/" target="_blank" rel="noopener">
                Visit HaiFive
              </Button>
            </div>
          </div>
        </div>
      </div>
      <img src="/ONIGIRI.png" alt="Onigiri" className={styles.image} />
    </div>
  );
}
